import * as React from "react";
import { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { useSpring, animated } from "@react-spring/web";
import { TfiRulerAlt } from "react-icons/tfi";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { TestLanguage } from "../hooks/testLanguage";
import { FaLocationDot } from "react-icons/fa6";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";

export default function Carddcar({ data }) {
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();

  const animationProps = useSpring({
    opacity: hovered ? 0.75 : 0.8,
    transform: hovered ? "translateY(-100px)" : "translateY(-35px)",
    config: { tension: 180, friction: 50 },
  });

  return (
    <animated.div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)} // 🧠 Add this to hide details on leave
    >
      <Card
        sx={{
        
          position: "relative",
          marginBottom: "20px",
          cursor: "pointer",
          boxShadow:
            "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
        }}
      >
        <CardMedia
          sx={{ height: 200, position: "relative" }}
          image={`${process.env.REACT_APP_IMAGE}${data.car_image}`}
          title="Car image"
        />
        <h6
          style={{
            position: "absolute",
            fontSize: "16px",
            fontFamily: "Oswald,Cairo, sans-serif",
            top: "2px",
            right: "0px",
            padding: "5px 10px",
            borderRadius: "4px 0px 0px 4px",
            backgroundColor: "#f5f5f5",
            opacity: "0.75",
            fontWeight: "300",
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
          }}
        >
          {" "}
          {TestLanguage(data?.status, "name")}
        </h6>
        <animated.div style={animationProps}>
          <CardContent
            sx={{
              paddingTop: "5px",
              height: 130,
              backgroundColor: "#f5f5f5",
              fontFamily: "Oswald,Cairo, sans-serif",
              position: "absolute",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Oswald,Cairo, sans-serif",
                fontSize: "15px",
                fontWeight: "300px",
                color: "#000",
                direction: t("directions.dir"),
              }}
              gutterBottom
              component="div"
            >
              <Grid container spacing={0}>
                <Grid size={10}>
                  {TestLanguage(data?.car_model, "name")} {data?.car_submodel}{" "}
                  {data?.made_year}{" "}
                </Grid>
                <Grid size={2}>
                  {/* {TestLanguage(data, "address")} */}
                  
                  <span style={{ fontSize: "12px" }}>{data.views}</span>{" "}<MdOutlineRemoveRedEye />
                </Grid>
              </Grid>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                color: "#000",
                direction: t("directions.dir"),
              }}
            >
              <FaLocationDot style={{ marginRight: "7px" }} />
              {TestLanguage(data?.city, "name")} -{" "}
              {TestLanguage(data?.region, "name")}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Oswald,Cairo, sans-serif",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                color: "#000",
                direction: t("directions.dir"),
              }}
            >
              <FaRegMoneyBillAlt
                style={{
                  color: "#fff",
                  padding: "3px",
                  marginRight: "5px",
                  fontSize: "22px",
                  color: "#000",
                }}
              />
              {data.price}$
            </Typography>
          </CardContent>
        </animated.div>
      </Card>
    </animated.div>
  );
}
